import { usePageHeader } from "@hooks/use_page_header";
import moment from "moment-timezone";
import { useLocation } from "react-router-dom";
import { LuBookMarked, LuCalendar, LuFileText } from "react-icons/lu";

moment.locale("id");

type StatCardProps = {
  label: string;
  value: string | number;
  bg: string;
  text: string;
  ring: string;
};

const StatCard = ({ label, value, bg, text, ring }: StatCardProps) => (
  <div
    className="tw-flex-1 tw-rounded-2xl tw-py-4 tw-text-center"
    style={{ background: bg, border: `1.5px solid ${ring}` }}
  >
    <div className="tw-text-2xl tw-font-bold" style={{ color: text }}>
      {value ?? "-"}
    </div>
    <div className="tw-text-[10px] tw-font-semibold tw-mt-0.5" style={{ color: text }}>
      {label}
    </div>
  </div>
);

const Divider = () => <div className="tw-h-px" style={{ background: "#f1f1f1" }} />;

export const TafaquhDetailPage = () => {
  const { state } = useLocation();
  usePageHeader("Detail Tafaquh", { bottomNavigation: "hidden" });

  return (
    <div className="tw-px-4 tw-pt-2 tw-pb-20 tw-space-y-3">

      {/* Hero card */}
      <div className="card-body tw-text-center tw-py-6">
        <div
          className="tw-inline-flex tw-items-center tw-justify-center tw-rounded-3xl tw-w-16 tw-h-16 tw-mb-4"
          style={{ background: "#f5f3ff" }}
        >
          <LuBookMarked className="tw-text-3xl tw-text-[#7c3aed]" />
        </div>

        <div className="tw-text-lg tw-font-bold tw-text-text-primary tw-mb-1 tw-px-4">
          {state?.namaKitab ?? "-"}
        </div>

        {state?.materi && (
          <div className="tw-text-sm tw-text-text-secondary tw-mb-2 tw-px-4">
            {state.materi}
          </div>
        )}

        <div className="tw-flex tw-items-center tw-justify-center tw-gap-1.5 tw-text-xs tw-text-text-secondary">
          <LuCalendar className="tw-text-sm" />
          {moment(state?.tanggal ?? Date.now()).format("dddd, DD MMMM YYYY")}
        </div>
      </div>

      {/* Scores grid */}
      <div className="card-body">
        <div className="tw-flex tw-items-center tw-gap-2 tw-mb-3">
          <div className="tw-w-1 tw-h-4 tw-rounded-full tw-bg-primary" />
          <span className="tw-text-xs tw-font-bold tw-text-text-secondary tw-uppercase tw-tracking-widest">
            Nilai
          </span>
        </div>

        <div className="tw-flex tw-gap-2">
          <StatCard
            label="Bacaan"
            value={state?.bacaan ?? "-"}
            bg="#eff6ff"
            text="#2563eb"
            ring="#bfdbfe"
          />
          <StatCard
            label="Hafalan"
            value={state?.hafalan ?? "-"}
            bg="#f0fdf4"
            text="#16a34a"
            ring="#bbf7d0"
          />
          <StatCard
            label="Makna"
            value={state?.makna ?? "-"}
            bg="#f5f3ff"
            text="#7c3aed"
            ring="#ddd6fe"
          />
        </div>

        {state?.keterangan && state.keterangan !== "-" && (
          <>
            <Divider />
            <div className="tw-pt-2.5 tw-pb-1">
              <div className="tw-flex tw-items-center tw-gap-1.5 tw-mb-1.5">
                <LuFileText className="tw-text-sm tw-text-text-secondary" />
                <span className="tw-text-xs tw-text-text-secondary">Keterangan</span>
              </div>
              <p className="tw-text-sm tw-font-semibold tw-text-text-primary tw-leading-relaxed">
                {state.keterangan}
              </p>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
